import React, { useState, useEffect, useMemo } from "react";
import {
  GetModulesByCourseId,
  GetAllModules,
} from "../../actions/adminQueries";
import { Badge, Button, Row, Col, Input, Table } from "reactstrap";
import CreateModule from "../../components/Modal/CreateModule";
import ModuleTypeIcon from "../../components/Module/ModuleTypeIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  getWinOptions,
  composeUrl,
  openWindowBeforeRequest,
} from "../../Utilities/moduleHelper";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import axios from "../../services/api/api";
import { API_BASE_URL } from "../../constants/api.constants";
import Pacmanloader from "../../components/Pacmanloader/Pacmanloader";
import SetCourseModuleSortOrderModal from "../../components/Modal/SetCourseModuleSortOrderModal";
import { UnlockTeacherFinalExam } from "../../actions/teacherMutations";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";
import { formatServiceError } from "../../Utilities/serviceErrorHelper";
import PromptGeneric from "../../components/Modal/PromptGeneric";
import { useIntl } from "react-intl";
import { useNavigate, useLocation } from "react-router-dom";
import useRedirectIf from "../../hooks/useRedirectIf";

function CourseModulesList() {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const [filterSearch, setFilterSearch] = useState("");
  const [createModal, setCreateModal] = useState(false);
  const [courseModuleToRemove, setCourseModuleToRemove] = useState(null);
  const [allModules, setAllModules] = useState([]);
  const [currentModules, setCurrentModules] = useState([]);
  const [sortModalIsOpen, setSortModalIsOpen] = useState(false);
  const [editDefQuesCountModuleId, setEditDefQuesCountModuleId] =
    useState(null);
  const [newDefaultQuesCount, setNewDefaultQuesCount] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const courseModules = GetModulesByCourseId(location.state?.courseId);
  const allModulesQuery = GetAllModules();

  const allModulesData = useMemo(
    () => allModulesQuery.data || [],
    [allModulesQuery.data],
  );
  const courseModulesData = useMemo(
    () => courseModules.data || [],
    [courseModules.data],
  );

  useEffect(() => {
    if (allModulesData.length > 0) {
      setAllModules(
        [...allModulesData].sort((a, b) =>
          a.sortOrder > b.sortOrder ? 1 : b.sortOrder > a.sortOrder ? -1 : 0,
        ),
      );
    }
    if (courseModulesData.length > 0) {
      setCurrentModules(courseModulesData);
    }
  }, [allModulesData, courseModulesData]);

  useEffect(() => {
    if (filterSearch.length > 0) {
      setCurrentModules(
        courseModulesData.filter((mod) => {
          if (mod.module.name.toLowerCase().indexOf(filterSearch) !== -1) {
            return mod;
          }
          return null;
        }),
      );
    }
  }, [filterSearch, courseModulesData]);

  useRedirectIf("/superuser/courses", !location.state);

  if (!location.state) {
    return null;
  }

  if (courseModules.isPending) {
    return <Pacmanloader />;
  }

  const loadModules = () => {
    courseModules.refetch();
  };

  const toggleModal = () => {
    setCreateModal(!createModal);
  };

  const removeCourseModule = () => {
    const courseModule = courseModuleToRemove;
    setCourseModuleToRemove(null);

    axios
      .delete(
        `${API_BASE_URL}/Course/CourseModule/${courseModule.courseModuleId}`,
      )
      .then(() => {
        toast.success(
          intl.formatMessage(
            { id: "ModuleRemovedFromCourse" },
            { name: courseModule.module.name },
          ),
          TOAST_CONFIG,
        );
        loadModules();
      })
      .catch((err) => {
        toast.warn(formatServiceError(intl, err?.response?.data), TOAST_CONFIG);
      });
  };

  const setHideStatus = (courseModuleId, hideForStudents, hideForTeachers) => {
    axios
      .post(`${API_BASE_URL}/Module/SetHideStatus/`, {
        id: courseModuleId,
        hideForStudents: hideForStudents,
        hideForTeachers: hideForTeachers,
      })
      .then(() => {
        toast.success(
          intl.formatMessage({ id: "HideStatusChanged" }),
          TOAST_CONFIG,
        );
        loadModules();
      })
      .catch((err) => {
        toast.warn(
          err && err.response && err.response.data
            ? formatServiceError(intl, err.response.data)
            : intl.formatMessage({ id: "CouldNotSetHideStatus" }),
          TOAST_CONFIG,
        );
      });
  };

  const handleFilterSearch = (event) => {
    setFilterSearch(event.target.value);
  };

  const getAllModulesNotInThisCourse = () => {
    var currentModules = courseModules.data || [];

    var currentModulesToCourseIds = currentModules.map((x) => x.moduleId);

    var notInThisCourse = allModules.filter((mod) => {
      if (currentModulesToCourseIds.indexOf(mod.id) === -1) {
        return mod;
      }

      return null;
    });

    return notInThisCourse;
  };

  const openModule = (
    courseId,
    moduleId,
    moduleUrl,
    moduleType,
    isGy25FinalExam,
  ) => {
    const studentResultId = -1;
    const userId = -1;

    if (moduleUrl == null) {
      toast.error(
        <FormattedMessage id="Tostify.Message.ModuleUrlMissing" />,
        TOAST_CONFIG,
      );
      return;
    }
    const win = openWindowBeforeRequest(intl, getWinOptions());
    if (!win) return;
    UnlockTeacherFinalExam(courseId, moduleId)
      .then(() => {
        var url = composeUrl(
          userId,
          courseId,
          moduleId,
          moduleType,
          studentResultId,
          moduleUrl,
          null,
          null,
          isGy25FinalExam,
        );

        win.location.href = url;
      })
      .catch((err) => {
        win.close();
        toast.warn(formatServiceError(intl, err?.response?.data), TOAST_CONFIG);
      });
  };

  const handleSetDefNbrOfFinalExamQuestions = (courseModuleId, value) => {
    axios
      .post(
        `/Module/SetDefNbrOfFinalExQuestions?courseModuleId=${courseModuleId}&defaultNumberOfQuestions=${value}`,
      )
      .then((response) => {
        toast.success(
          <FormattedMessage id="DefaultQuestionCountChangeSuccess" />,
          TOAST_CONFIG,
        );
        setCurrentModules((prevModules) =>
          prevModules.map((module) =>
            module.courseModuleId === courseModuleId
              ? {
                  ...module,
                  defNbrOfFinalExQuestions:
                    response.data.result.defNbrOfFinalExQuestions,
                }
              : module,
          ),
        );
      })
      .catch((err) => {
        toast.warn(
          err && err.response && err.response.data && (
            <FormattedMessage id="DefaultQuestionCountChangeFail" />
          ),
          TOAST_CONFIG,
        );
      });
  };

  const validateInput = (value, defaultValue, maxValue) => {
    if (isNaN(value) || value < 0) {
      setErrorMessage(intl.formatMessage({ id: "EnterValidNumber" }));
      return false;
    }
    if (maxValue != null && maxValue !== "" && value > maxValue) {
      setErrorMessage(intl.formatMessage({ id: "EnterSmallerNumber" }));
      return false;
    }
    if (value === defaultValue) {
      setEditDefQuesCountModuleId(null);
      setNewDefaultQuesCount("");
      return false;
    }
    setErrorMessage("");
    return true;
  };

  const handleBlur = (courseModule, maxQuestions, inputValue) => {
    const parsedValue = parseInt(inputValue, 10);
    const defaultNumber = courseModule.defNbrOfFinalExQuestions;

    if (!validateInput(parsedValue, defaultNumber, maxQuestions)) return;

    handleSetDefNbrOfFinalExamQuestions(
      courseModule.courseModuleId,
      parsedValue,
    );
    setEditDefQuesCountModuleId(null);
    setNewDefaultQuesCount("");
  };

  const getMaxNumberOfQuestions = (courseModule) => {
    if (courseModule.module.hasQApiFetchError) return "E";
    return courseModule.module.numberOfQuestions ?? "";
  };

  const renderQuestionCountInput = (courseModule) => {
    const defaultCount = courseModule.defNbrOfFinalExQuestions ?? 0;
    const maxQuestions = getMaxNumberOfQuestions(courseModule);
    const isEditing =
      maxQuestions !== 0 &&
      editDefQuesCountModuleId === courseModule.courseModuleId;
    const currentValue = isEditing ? newDefaultQuesCount : defaultCount;

    return (
      <>
        {courseModule.module.isGy25TestModule &&
          !courseModule.module.isFinalExam && (
            <div className="set-number-section d-flex align-items-center">
              {isEditing ? (
                <Input
                  type="number"
                  min="0"
                  max={maxQuestions}
                  value={currentValue}
                  onBlur={() =>
                    handleBlur(courseModule, maxQuestions, currentValue)
                  }
                  onKeyDown={(e) =>
                    e.key === "Enter" &&
                    handleBlur(courseModule, maxQuestions, currentValue)
                  }
                  onChange={(e) => setNewDefaultQuesCount(e.target.value)}
                  className="number-input"
                  title={errorMessage}
                />
              ) : (
                <Button
                  onClick={() => {
                    setEditDefQuesCountModuleId(courseModule.courseModuleId);
                    setNewDefaultQuesCount(defaultCount);
                  }}
                  className="btn-set-number p-1"
                  title={intl.formatMessage({
                    id: "DefaultQuestionCountTooltip",
                  })}
                >
                  {defaultCount === "" ? (
                    <FontAwesomeIcon icon={faPen} />
                  ) : (
                    defaultCount
                  )}
                </Button>
              )}
              {maxQuestions !== "" && (
                <>
                  <span className="me-1">/</span>
                  <span
                    title={
                      courseModule.module.hasQApiFetchError
                        ? intl.formatMessage({
                            id: "CouldNotGetMaxValue",
                          })
                        : intl.formatMessage({ id: "MaxQuestionCount" })
                    }
                    className={
                      courseModule.module.hasQApiFetchError &&
                      "text-danger input-feedback"
                    }
                  >
                    {maxQuestions}
                  </span>
                </>
              )}
              {defaultCount !== "" && (
                <span className="set-number-span">
                  <FontAwesomeIcon icon={faPen} className="edit-icon" />{" "}
                </span>
              )}
            </div>
          )}
      </>
    );
  };

  var mappedModulesComp = currentModules?.map((courseModule, id) => {
    return (
      <tr key={id} style={{ verticalAlign: "middle" }}>
        <td>
          <ModuleTypeIcon moduleType={courseModule.module.moduleType} />
        </td>
        <td>
          {courseModule.module.moduleType !== "LearnWare" ? (
            <Button
              color="link"
              onClick={() =>
                openModule(
                  courseModule.courseId,
                  courseModule.moduleId,
                  courseModule.module.url,
                  courseModule.module.moduleType,
                  courseModule.module.isFinalExam &&
                    courseModule.module.maxScoreIsSetByModule,
                )
              }
              disabled={
                (courseModule.module.isFinalExam &&
                  courseModule.module.maxScoreIsSetByModule) ||
                courseModule.module.isPreview
              }
            >
              <FontAwesomeIcon
                icon="circle-play"
                size="2x"
                className="text-primary"
              />
            </Button>
          ) : (
            ""
          )}
        </td>
        <td>{courseModule.module.name}</td>
        <td align="right">{courseModule.moduleId}</td>
        <td align="right">{courseModule.courseModuleId}</td>
        <td align="right">{courseModule.module.moduleCoupleId}</td>
        <td align="right">{courseModule.module.maxScore}</td>
        <td align="right">{courseModule.module.approveScoreLimit}</td>
        <td align="right">{courseModule.module.maxActivityPoints}</td>

        <td align="center">
          {courseModule.module.isFinalExam ? (
            <FontAwesomeIcon icon="check" />
          ) : (
            <span />
          )}
        </td>
        <td align="center">
          {courseModule.module.maxScoreIsSetByModule ? (
            <FontAwesomeIcon icon="check" />
          ) : (
            <span />
          )}
        </td>
        <td align="center">
          {courseModule.module.isFactModule ? (
            <FontAwesomeIcon icon="check" />
          ) : (
            <span />
          )}
        </td>
        <td align="center">{renderQuestionCountInput(courseModule)}</td>
        <td align="center">
          <Button
            size="sm"
            outline
            color="blue"
            onClick={() =>
              setHideStatus(
                courseModule.courseModuleId,
                !courseModule.hideForStudents,
                courseModule.hideForTeachers,
              )
            }
          >
            <FontAwesomeIcon
              icon="check"
              opacity={courseModule.hideForStudents ? 1 : 0}
            />
          </Button>
        </td>

        <td align="center">
          <Button
            size="sm"
            outline
            color="blue"
            onClick={() =>
              setHideStatus(
                courseModule.courseModuleId,
                courseModule.hideForStudents,
                !courseModule.hideForTeachers,
              )
            }
          >
            <FontAwesomeIcon
              icon="check"
              opacity={courseModule.hideForTeachers ? 1 : 0}
            />
          </Button>
        </td>

        <td>
          {courseModule.module.isPreview && (
            <Badge color="info" pill style={{ fontSize: "0.9rem" }}>
              {courseModule.module.previewText}
            </Badge>
          )}
          {courseModule.module.qApiId && (
            <div>{courseModule.module.qApiId}</div>
          )}
        </td>

        <td>
          <Button
            size="sm"
            outline
            color="danger"
            title={intl.formatMessage(
              { id: "RemoveModuleFromCourse" },
              { moduleName: courseModule.module.name },
            )}
            onClick={() => setCourseModuleToRemove(courseModule)}
          >
            <FontAwesomeIcon icon="trash" />
          </Button>
        </td>
      </tr>
    );
  });

  return (
    <div>
      <div className="card card-body">
        <h5 className="no-margin">
          <Button color="link" onClick={() => navigate("/superuser/courses")}>
            <span className="fa fa-chevron-left fa-2x" />
          </Button>
          {location.state.courseName} : <FormattedMessage id="LinkedModules" />
          <Button
            color="link"
            className="float-end"
            onClick={() => {
              toggleModal();
            }}
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <FormattedMessage id="LinkExistingModule" />
          </Button>
          <span className="ms-2">
            (
            <FormattedMessage id="CourseId" /> {location.state.courseId})
          </span>
          <Button
            color="link"
            className="float-end"
            onClick={() => {
              setSortModalIsOpen(!sortModalIsOpen);
            }}
          >
            <FontAwesomeIcon icon="edit" />
            &nbsp;
            <FormattedMessage id="ChangeOrderForModulesInCourse" />
          </Button>
        </h5>
      </div>
      <div
        className="container-fluid admin-container "
        style={{ overflowX: "auto" }}
      >
        <Row>
          <Col className="col-12">
            <Row>
              <Col className="col-3 mb-2">
                <Input
                  className="search-input"
                  placeholder={intl.formatMessage({ id: "SearchModule" })}
                  onChange={handleFilterSearch.bind(this)}
                />
              </Col>
            </Row>
            <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
              <Table hover className="table table-striped">
                <thead className="sticky-header">
                  <tr>
                    <th>
                      <FormattedMessage id="Type" />
                    </th>
                    <th>
                      <FormattedMessage id="Test" />
                    </th>
                    <th>
                      <FormattedMessage id="Name" />
                    </th>
                    <th style={{ textAlign: "right" }}>
                      <FormattedMessage id="ModuleId" />
                    </th>
                    <th style={{ textAlign: "right" }}>
                      <FormattedMessage id="CourseModuleId" />
                    </th>
                    <th style={{ textAlign: "right" }}>
                      <FormattedMessage id="CoupleId" />
                    </th>
                    <th style={{ textAlign: "right" }}>
                      <FormattedMessage id="MaxScore" />
                    </th>
                    <th style={{ textAlign: "right" }}>
                      <FormattedMessage id="ApproveScoreLimitInPercentage" />
                    </th>
                    <th style={{ textAlign: "right" }}>
                      <FormattedMessage id="MaxActivityPoints" />
                    </th>
                    <th>
                      <FormattedMessage id="FinalExam" />
                    </th>
                    <th>
                      <FormattedMessage id="Gy25" />
                    </th>
                    <th>
                      <FormattedMessage id="FactModule" />
                    </th>
                    <th
                      title={intl.formatMessage({
                        id: "QuestionCountHeaderTooltip",
                      })}
                    >
                      <FormattedMessage id="QuestionCountDefMax" />
                    </th>
                    <th>
                      <FormattedMessage id="HiddenForStudents" />
                    </th>
                    <th>
                      <FormattedMessage id="HiddenForTeachers" />
                    </th>
                    <th>
                      <FormattedMessage id="QApiId" />
                      {" / "}
                      <FormattedMessage id="Preview" />
                    </th>
                    <th>
                      <FormattedMessage id="Delete" />
                    </th>
                  </tr>
                </thead>
                <tbody>{mappedModulesComp}</tbody>
              </Table>
            </div>
          </Col>
        </Row>
      </div>

      <CreateModule
        isOpen={createModal}
        toggle={toggleModal}
        courseName={location.state.courseName}
        courseId={location.state.courseId}
        modules={getAllModulesNotInThisCourse()}
        reloadModules={loadModules}
      />
      <SetCourseModuleSortOrderModal
        isOpen={sortModalIsOpen}
        toggle={() => setSortModalIsOpen(!sortModalIsOpen)}
        modules={currentModules}
        courseId={location.state.courseId}
        reloadModules={loadModules}
      />
      <PromptGeneric
        isOpen={courseModuleToRemove !== null}
        toggle={() => setCourseModuleToRemove(null)}
        onProceed={removeCourseModule}
        danger={true}
        btnText="Delete"
        title={<FormattedMessage id="AreYouSure" />}
        text={intl.formatMessage(
          { id: "AreYouSureRemoveModuleFromCourse" },
          { name: courseModuleToRemove?.module.name ?? "" },
        )}
      />
    </div>
  );
}

export default CourseModulesList;
